import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=007cb0dc&scoped=true&component=true&componentId=index216564cb"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index216564cb"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index216564cb"
import style0 from "./index.mpx?vue&type=style&index=0&id=007cb0dc&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m216564cb%22%7D&component=true&componentId=index216564cb"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007cb0dc",
  null
  
)

export default component.exports